//import { parseISO } from 'date-fns';
import max from 'date-fns/max';
import min from 'date-fns/min';
//import parseJSON from 'date-fns/parseJSON';
import moment from 'moment';
export const getMinMaxDates = (dates: Array<any>) => {
	return { max: max(dates), min: min(dates) };
};

export const getMinMaxDatesParse = (datesInISOString: Array<any>) => {
	let dates = [];

	// dates = datesInISOString.map((date: string) => {
	// 	return parseJSON(date);
	//});

	dates = datesInISOString.map((date: string) => {
		return moment(moment(date).format('YYYY-MM-DD')).toDate();
	});
	console.warn('DATES ', dates);
	console.warn('count ', dates.length);
	return getMinMaxDates(dates);
};
